import React, { useState, useEffect } from "react";
import { FaHeart, FaTimes, FaMapMarkerAlt, FaBriefcase, FaUser, FaStar, FaCommentDots } from "react-icons/fa"; 
import { Link } from "react-router-dom";
import axios from "axios";
import { baseurl, imgurl } from "../baseurl";
import { getStoredToken } from "../component/utils/getStoredToken";

// Assuming these are your default placeholders
import male from "../assets/img/male.png";
import female from "../assets/img/female.png";
import ChatDrawer from "./ChatDrawer";

import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import InterestButtonCard from "./InterestButtonCard";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
  customClass: {
    popup: "swal2-toast-custom",
  },
});


function PartnerCardsMobile() {
 const token = getStoredToken();
 const [profiles, setProfiles] = useState([]);
 const [loading, setLoading] = useState(true); 

 useEffect(() => {
  const fetchMatches = async () => {
   if (!token) return;

   try {
    setLoading(true);
    const res = await axios.get(`${baseurl}getMatchedUsers`, {
     headers: { Authorization: `Bearer ${token}` },
    });

    if (res.data.success) {
     const matches = res.data.matches.map((p) => ({
      id: p.id,
      uid: p.uid,
      display_id: p.display_id,
      name: `${p.first_name} ${p.last_name}`,
      age: Math.floor((new Date() - new Date(p.date_of_birth)) / (1000 * 60 * 60 * 24 * 365)),
      height: p.height , 
      city: p.location?.split(',')[0] || "N/A", 
      current_occupation: p.current_occupation || "N/A",
      annual_income: p.annual_income ? `Earns ₹${p.annual_income} Lacs p.a` : "No Income", // Added currency
      profession: p.profession || "N/A",
      religion: p.religion || "N/A",
      sect: p.sect || "N/A",
      marital_status: p.marital_status || "N/A",
      education: p.education || "N/A",
      profile_managed_by: p.profile_managed_by || "Self",
      gender: p.gender || "N/A",
      image: p.main_photo
       ? `${imgurl}${p.main_photo}`
       : p.gender?.toLowerCase() === "female"
        ? female
        : male,
     }));
     setProfiles(matches);
    }
   } catch (err) {
    console.error("Error fetching matches:", err);
   } finally {
    setLoading(false);
   }
  };

  fetchMatches();
 }, [token]);


 // Placeholder function for action logic (e.g., sending interest)
//  const handleAction = (profileId, actionType) => {
//   console.log(`Action: ${actionType} on profile ${profileId}`);
   
//  };

 // Skeleton Loader for list view
 const renderSkeletons = () => {
  const skeletons = Array.from({ length: 3 }); 
  return skeletons.map((_, idx) => (
   <div key={idx} className="card-mobile-block">
    <div className="card-mobile-container">
      <div className="skeleton-card-img" style={{height: '350px'}}></div>
      <div className="skeleton-card-details" style={{height: '120px'}}></div>
    </div>
        <div className="action-button-bar-mobile">
            <div className="skeleton-action-btn"></div>
            <div className="skeleton-action-btn"></div>
            <div className="skeleton-action-btn"></div>
            <div className="skeleton-action-btn"></div>
        </div>
   </div>
  ));
 };




 
const [chatOpen, setChatOpen] = useState(false);
const [selectedUid, setSelectedUid] = useState(null);

const sendSuperInterest = async (profileId) => {
  const payload = { profile_id: profileId };

  try {
    const res = await axios.post(
      `${baseurl}sendSuperInterest`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.success) {
      Toast.fire({
        icon: "success",
        title: "Super Interest Sent!",
      });
    } else {
      Toast.fire({
        icon: "error",
        title: "Failed to send Super Interest",
      });
    }
  } catch (error) {
    Toast.fire({
      icon: "error",
      title: "Something went wrong",
    });
  }
};


// Send Shortlist API
const sendShortlist = async (profileId) => {
  const payload = { profile_id: profileId };

  console.log("👉 Sending Shortlist Payload:", payload);

  try {
    const res = await axios.post(
      `${baseurl}shortlistUser`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    console.log("✅ Shortlist Response:", res.data);

    if (res.data.success) {
      console.log("User shortlisted!");
    } else {
      console.log("Failed to shortlist");
    }
  } catch (error) {
    console.error("❌ Shortlist error:", error);
  }
};


const handleAction = (profileId, actionType) => {
  console.log(`Action: ${actionType} on profile ${profileId}`);

  if (actionType === "SuperInterest") {
    sendSuperInterest(profileId);
  }

  if (actionType === "Shortlist") {
    sendShortlist(profileId);
  }

  // Interest can be added later if needed
};

 return (
  <>
 
    <div className="mobile-card-list-wrapper my-3">
      {loading ? (
        renderSkeletons()
      ) : profiles.length > 0 ? (
        profiles.map((p) => (
          <div key={p.id} className="card-mobile-block">
                        {/* Image and Details Area (Clickable) */}
            <Link to={`/profile/view/${p.uid}`} style={{ textDecoration: 'none', display: 'block' }}>
                            <div className="card-mobile-container">
                  {/* Profile Image */}
                <img 
                  src={p.image} 
                  alt={p.name} 
                  className="profile-card-img-mobile" 
                />
                
                {/* Top Badges */}
                {/* <span className="top-badge-mobile">
                  Most Compatible
                </span> */}
                {/* <span className="image-count-mobile">
                  🖼️ 4 
                </span> */}
                
                {/* Gradient Overlay */}
                <div className="card-gradient-overlay-mobile"></div>
                
                {/* Details Area */}
                <div className="card-details-mobile">
                  <h3 className="d-flex align-items-center">
                    {p.display_id}, {p.age} 
                    {/* <span className="top-badge-verified">Verified ✔️</span>  */}
                  </h3>
                  
                  <p>
                    <strong>{p.height}</strong> • <strong>{p.city}</strong> • {p.religion} ({p.sect})
                  </p>
                  
                  <p>
                    {p.current_occupation} / {p.profession} ({p.annual_income})
                  </p>
                  
                  <p>
                    {p.education} • {p.marital_status} • No Children
                  </p>
                  
                  <p style={{fontSize: '0.75rem', opacity: 0.8, marginTop: '5px'}}>
                    Profile managed by {p.profile_managed_by}
                  </p>
                </div>
                            </div>
                        </Link>

                        {/* Action Button Bar (Always visible below the image/details block) */}
            <div className="action-button-bar-mobile">
              {/* Interest (Red/Heart) */}
              {/* <a href="#" className="action-btn-mobile" onClick={() => handleAction(p.id, 'Interest')}>
                <div className="action-icon-mobile icon-interest"><FaHeart /></div>
                Interest
              </a> */}


<InterestButtonCard uid = {p.uid} />

              
              {/* Super Interest (Green/Times/Skip) */}
            <a
  href="#"
  className="action-btn-mobile"
  onClick={(e) => {
    e.preventDefault();  // 🔥 stops scroll to top
    handleAction(p.id, "SuperInterest");
  }}
>
                <div className="action-icon-mobile icon-super-interest"><FaTimes /></div>
                Super Interest
              </a>

              {/* Shortlist (Yellow/Star) */}
              {/* <a href="#" className="action-btn-mobile" onClick={() => handleAction(p.id, 'Shortlist')}>
                <div className="action-icon-mobile icon-shortlist"><FaStar /></div>
                Shortlist
              </a> */}
              
              {/* Chat (Blue/Comment) */}
             <Link
  className="action-btn-mobile"
  onClick={() => {
    setSelectedUid(p.uid);
    setChatOpen(true);
  }}
>
  <div className="action-icon-mobile icon-chat"><FaCommentDots /></div>
  Chat
</Link>

<ChatDrawer
  uid={selectedUid}
  show={chatOpen}
  onClose={() => {
    setChatOpen(false);
    setSelectedUid(null);   // RESET UID on close
  }}
/>
            </div>
          </div>
        ))
      ) : (
        <div className="text-center py-5">
          <p>No recommended profiles found yet.</p>
        </div>
      )}
    </div>


    
<style>{`
      /* Wrapper ensures responsiveness and central alignment for mobile view */
      .mobile-card-list-wrapper {
        max-width: 450px; /* Max width for a clean mobile look */
        margin: 0 auto;
        padding: 0 10px; /* Padding for edges */
                min-height: 100vh;
      }
            
            /* Container for each profile card */
            .card-mobile-block {
                margin-bottom: 25px; /* Space between cards */
                background: #fff;
                border-radius: 15px;
                box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
                overflow: hidden;
            }

      .card-mobile-container {
        position: relative;
        width: 100%;
                height: 400px; /* Fixed height for image area */
        overflow: hidden;
      }

      .profile-card-img-mobile {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      .card-gradient-overlay-mobile {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 60%; /* Adjusted height for detail visibility */
        background: linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0));
        pointer-events: none;
      }
      
      .card-details-mobile {
        position: absolute;
        bottom: 0; /* Align details to the very bottom */
        left: 0;
        width: 100%;
        padding: 0 15px 15px 15px;
        color: #fff;
        z-index: 10;
      }

      .card-details-mobile h3 {
        font-size: 1.6rem;
        font-weight: 700;
        margin-bottom: 5px;
      }

      .card-details-mobile p {
        font-size: 0.9rem;
        margin-bottom: 5px;
        line-height: 1.4;
      }
            
            .card-details-mobile strong {
                font-weight: 600;
            }

      .top-badge-mobile {
        position: absolute;
        top: 15px;
        left: 15px;
        background: #3498db; /* Blue for 'Most Compatible' */
        color: #fff;
        padding: 5px 12px;
        border-radius: 50px;
        font-size: 0.8rem;
        font-weight: 600;
        z-index: 10;
      }
            
            // .top-badge-verified {
            //     background: #2ecc71; /* Green for 'Verified' */
            //     margin-left: 10px;
            // }
      
      .image-count-mobile {
        position: absolute;
        top: 15px;
        right: 15px;
        background: rgba(255, 255, 255, 0.8);
        color: #333;
        padding: 5px 10px;
        border-radius: 8px;
        font-size: 0.8rem;
        font-weight: 500;
        z-index: 10;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
      }

            /* Action Buttons BELOW the card image */
      .action-button-bar-mobile {
                display: flex;
                justify-content: space-around;
                padding: 10px 0;
                // background-color: #fff;
                background: linear-gradient(90deg, #131313ff 0%, #1b1b1bff 100%) !important;
                border-top: 1px solid #eee;
      }

      .action-btn-mobile {
                display: flex;
                flex-direction: column;
                align-items: center;
                text-decoration: none;
                color: #ffffffff;
                font-size: 0.7rem;
                font-weight: 600;
                transition: color 0.2s;
      }
            
            .action-btn-mobile:hover, .action-btn-mobile:focus {
                color: #333;
            }

      .action-icon-mobile {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.3rem;
        margin-bottom: 3px;
      }

      /* Specific button styling */
      .icon-interest { background-color: #383838c2; color: #ffffffff; } 
      .icon-super-interest { background-color: #383838c2; color: #ffffffff; } 
      .icon-shortlist { background-color: #383838c2; color: #ffffffff; } 
      .icon-chat { background-color: #383838c2; color: #ffffffff; } 

      /* Skeleton Styles */
      .skeleton-card-img { width: 100%; height: 100%; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite; border-radius: 15px 15px 0 0;}
      .skeleton-card-details { position: absolute; bottom: 10px; left: 15px; width: 80%; height: 100px; background-color: rgba(255, 255, 255, 0.2); border-radius: 5px; }
      .skeleton-action-btn { width: 45px; height: 45px; border-radius: 50%; background-color: #e0e0e0; }

      @keyframes loading {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }
    `}</style>


  </>
 );
}

export default PartnerCardsMobile;




